import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export function ShadowCreationModalBody({ grid, grids, onGridChange }) {
  return (
    <ManagedFormGroup
      getOptionLabel={grid => grid.name}
      getOptionValue={grid => grid.id}
      label="Grid Template"
      options={grids}
      type="combobox"
      value={grid}
      onValueChange={onGridChange}
    />
  );
}

ShadowCreationModalBody.propTypes = {
  grid: PropTypes.object,
  grids: PropTypes.array.isRequired,
  onGridChange: PropTypes.func.isRequired,
};

export default ShadowCreationModalBody;
